import { useEffect, useMemo, useState } from "react";
import { Container } from "../../shared/Components/Container/Container";
import { ElementBreadCrumb } from "../../shared/Components/ElementBreadCrumb";
import { ElementItemCardGenerico } from "../../shared/Components/Programados/ElementItemCardGenerico";
import { InputSearch } from "../../shared/Components/ReactBootstrap/InputSearch/InputSearch";
import { LanguageTranslate } from "../../shared/Infraestructure/LanguageTranslate";
import { useSelector } from "react-redux";
import { RootState } from "../../shared/Infraestructure/AdapterStore";
import { ViewError } from "../../shared/Components/ViewError";
import { getChannelName } from "sigo-package";
import { RepositoryImplMain } from "../../../app/Infraestructure/RepositoryImplMain";
import { useDispatch } from "react-redux";
import { SistemaRecurso, StateInternalOrderTOA, TOAOrdenLiquidacionENTITY } from "sigo-entities";
import ButtonFloating from "../../shared/Components/ButtonFloating/ButtonFloating";
import { ViewLoading } from "../../shared/Components/ViewLoading";
import { OffCanvasBottom } from "../../shared/Components/ReactBootstrap/OffCanvasBottom/OffCanvasBottom";
import { AddInventory } from "./AddInventory";
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico";
import {
    useGetByIdTOAOrdersQuery,
    useLazyGetByIdTOAOrdersQuery,
    useSendReviewTOAOrdersMutation
} from "../../shared/Infraestructure/slice";

export function ViewOrdenesToa() {
    const languageTranslate = LanguageTranslate()
    const [searchTerm, setSearchTerm] = useState<string>('')
    const [show, setShow] = useState<boolean>(false)
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const { user, personal } = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch()
    const repository = new RepositoryImplMain(dispatch, 'procesos', 'PERU_9112_ToaOrderPreliquidacion')
    const { data, isLoading, isError, error } = useGetByIdTOAOrdersQuery(user.Identificacion)
    const [getByIdTOAOrders, { data: newData, isFetching, isError: isErrorLazy, error: errorLazy }] = useLazyGetByIdTOAOrdersQuery()
    const [sendReview, { isLoading: isLoadingSendReview }] = useSendReviewTOAOrdersMutation()
    const rutaOperaciones = '/main/operaciones'

    const currentData = newData ?? data ?? []

    const filteredData = currentData.filter((e) => {
        const term = searchTerm.trim().toUpperCase()
        if (!term) return true
        return (
            e.numero_de_peticion?.toUpperCase().includes(term) ||
            e.subtipo_de_actividad?.toUpperCase().includes(term) ||
            e.numero_ot?.toString().toUpperCase().includes(term)
        )
    })

    const Rooms = (id_recurso: string) => [
        {
            channel: getChannelName(id_recurso).updateDataTOAOrdersLiquidation,
            listener: async () => {
                await getByIdTOAOrders(user.Identificacion).unwrap()
            }
        }
    ]

    useEffect(() => {
        const idrecurso = personal?.RecursosPersonal.find(e => e.Sistema === SistemaRecurso.TOA_MOVISTAR)
        if (idrecurso) {
            repository.websocket.addChannelListener(Rooms(idrecurso.IdRecurso))
        }
    }, [])

    const selectedOrder = useMemo(
        () => data?.find((item) => item._id === selectedId),
        [data, selectedId]
    )

    const onAddInventoryClick = (e: TOAOrdenLiquidacionENTITY) => {
        try {
            setSelectedId(e._id)
            setShow(true)
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onSendReviewClick = async (e: TOAOrdenLiquidacionENTITY) => {
        try {
            await sendReview({ id: e._id }).unwrap()
            AdapterGenerico.createMessage('¡Éxito!', '¡Se envió a revisión!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onViewObservationClick = async (e: TOAOrdenLiquidacionENTITY) => {
        try {
            const msg = e.localidad ? e.localidad : 'No hay observación'
            AdapterGenerico.createMessage('Observación de rechazo', msg, 'error')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    if (isLoading || isFetching) return <ViewLoading />

    return (
        <Container>
            <ElementBreadCrumb list={[
                { text: languageTranslate.menu['070'].titulo, navigate: true, path: rutaOperaciones },
                { text: languageTranslate.menu['071'].titulo, navigate: false, path: '' }]}
            />
            <InputSearch
                handleChange={(text) => setSearchTerm(text.toUpperCase())}
            />
            {
                (isError || isErrorLazy)
                    ? <ViewError error={error || errorLazy} />
                    : isLoadingSendReview
                        ? <ViewLoading />
                        : <>
                            {
                                filteredData.map((e, i) => (
                                    <ElementItemCardGenerico
                                        key={i}
                                        icono
                                        onClick={() => onAddInventoryClick(e)}
                                        icono1='fa-solid fa-box-archive'
                                        icono2='fa-solid fa-share'
                                        icono3={e.estado_interno === StateInternalOrderTOA.RECHAZADO ? 'fa-solid fa-warning' : undefined}
                                        onClick2={onSendReviewClick}
                                        onClick3={onViewObservationClick}
                                        text1={<span style={{ fontSize: 14 }}>N° petición</span>}
                                        data1={<span style={{ color: '#e0e0e0' }}>{e.numero_de_peticion}</span>}
                                        text2={<span style={{ fontSize: 14 }}>Actividad</span>}
                                        data2={<span style={{ color: '#e0e0e0' }}>{e.subtipo_de_actividad}</span>}
                                        text3={<span style={{ fontSize: 14 }}>Número OT</span>}
                                        data3={<span style={{ color: '#e0e0e0' }}>{e.numero_ot}</span>}
                                        text4={<span style={{ fontSize: 14, color: 'white' }}>Estado</span>}
                                        data4={<span style={{ color: 'yellow' }}>{e.estado_actividad}</span>}
                                        text5={<span style={{ fontSize: 14, color: 'white' }}>Est. Interno</span>}
                                        data5={<span style={{ color: '#e0e0e0' }}>{e.estado_interno}</span>}
                                        item={e}
                                        backgroundColor={e.estado_interno === StateInternalOrderTOA.RECHAZADO ? '#c54a56ff' : undefined}
                                    />
                                ))
                            }
                        </>
            }
            <ButtonFloating
                onClick={async () => await getByIdTOAOrders(user.Identificacion).unwrap()}
                icono='fa-solid fa-arrows-rotate'
                colorIcono='#2C3E50'
            />
            <OffCanvasBottom
                height={100}
                show={show}
                setShow={setShow}
                children={
                    selectedOrder
                        ? <AddInventory
                            row={selectedOrder}
                        />
                        : null
                }
            />
        </Container>
    )
}